import React from "react";
import { useTranslation } from 'react-i18next';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer>
      <div>
        <a href="https://github.com/neyasru" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/joan-monge-tom%C3%A0s/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <div className="footer-text">
        <p>{t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer;